import { Snackbar } from '@mui/material';
import React from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { actionNotification } from 'hooks/use-action-notification';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ActionSnackBar: React.VFC = () => {
  const { alertState, clearAlert } = actionNotification.useController();

  if (!alertState?.isOpen) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={alertState?.isOpen}
      autoHideDuration={5000}
      onClose={() => clearAlert()}
      key="bottomright"
    >
      <Alert onClose={() => clearAlert()} severity={alertState.isSuccess ? 'success' : alertState.isError ? 'error' : 'warning'}>
        {alertState.message}
      </Alert>
    </Snackbar>
  );
};

export default ActionSnackBar;
